import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  container: {
    position: "relative",
    padding: "12px 44px 12px 12px",
    maxHeight: 320,
    overflow: "auto",
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    backgroundColor: "#fbfafb",
    fontFamily: "monospace",
    fontSize: "12px",
    lineHeight: 1.6
  },

  copyButton: {
    position: "absolute",
    top: 6,
    right: 6
  },

  copyIcon: {
    fontSize: "17px",
    color: "#736973"
  },

  node: {
    paddingLeft: "16px"
  },

  toggle: {
    display: "inline-block",
    width: "16px",
    marginLeft: "-16px",
    color: "#736973",
    cursor: "pointer",
    userSelect: "none"
  },

  key: {
    color: "#4b1c46"
  },

  punctuation: {
    color: "#8f8a8f"
  },

  string: {
    color: "#c2185b",
    wordBreak: "break-word"
  },

  number: {
    color: "#1565c0"
  },

  boolean: {
    color: "#7b1fa2"
  },

  nullValue: {
    color: "#8f8a8f"
  },

  summary: {
    color: "#8f8a8f",
    fontStyle: "italic"
  }
}));

export default useStyles;
